import React from 'react';
import { View } from 'react-native';
import { SvgFromUri } from 'react-native-svg';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';

interface IProps {
  size: number;
  marginHorizontal: number;
}

export function OrganisationIcon({ size = defaultScale(40), marginHorizontal = defaultScale(12) }: IProps) {
  if (!Theme.organisationIconUrl) {
    return <View />;
  }

  return (
    <View style={{ marginHorizontal, width: size, height: size }}>
      <SvgFromUri
        resizeMode='contain'
        width='100%'
        height='100%'
        uri={Theme.organisationIconUrl}
      />
    </View>
  );
}
